import { Suspense, useRef, useState, type FC } from 'react';
import { dibsLazy } from 'dibs-lazy/exports/dibsLazy.ts';

import { VisibilityTracker } from 'dibs-visibility-tracker/exports/VisibilityTracker.tsx';

import { useHomePageContext } from '../HomePageContext.tsx';
import { HpSharedCarouselTabsShimmer } from '../HpSharedCarouselTabs/HpSharedCarouselTabsShimmer.tsx';

const HpSharedNewArrivalsCarouselTabs = dibsLazy(
    'HpSharedNewArrivalsCarouselTabs',
    () =>
        import(
            /* webpackChunkName: "HpSharedNewArrivalsCarouselTabs" */ './HpSharedNewArrivalsCarouselTabs.tsx'
        )
);

type Props = {
    userId: string;
    isClient: boolean;
};

export const HpSharedNewArrivalsCarouselTabsLazy: FC<Props> = ({ userId, isClient }) => {
    const { isMobile } = useHomePageContext();
    const containerRef = useRef<HTMLDivElement>(null);
    const [hasBecomeVisible, setHasBecomeVisible] = useState(false);

    if (!isClient || !userId) {
        return null;
    }

    const shimmer = <HpSharedCarouselTabsShimmer isMobile={isMobile} />;

    return (
        <div ref={containerRef} data-tn="hp-new-arrivals-module">
            <VisibilityTracker
                elementRef={containerRef}
                onVisibilityChange={({ isVisible }) => {
                    if (isVisible) {
                        setHasBecomeVisible(true);
                    }
                }}
                observerOptions={{
                    rootMargin: isMobile ? '700px 0px' : '400px 0px',
                }}
            />
            {hasBecomeVisible ? (
                <Suspense fallback={shimmer}>
                    <HpSharedNewArrivalsCarouselTabs userId={userId} />
                </Suspense>
            ) : (
                shimmer
            )}
        </div>
    );
};
